<template>
  <div class="go-tip-pop">
    <div class="go-tip-arrow"></div>
    <div class="go-tip-card">
      <div class="go-tip-header">
        <span class="go-tip-badge">{{ $vuetify.t('$vuetify.groupOrder.tooltipBadgeNew') }}</span>
        <span class="go-tip-title">{{ $vuetify.t('$vuetify.groupOrder.tooltipTitle') }}</span>
        <button class="go-tip-close" @click="onDismiss">
          <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="#17181a" stroke-width="2" stroke-linecap="round"><path d="M7 7l10 10M17 7 7 17"></path></svg>
        </button>
      </div>

      <div class="go-tip-demo">
        <div v-if="sceneIndex === 0" key="0" class="go-tip-scene go-tip-scene-0">
          <span class="go-tip-fake-btn">
            <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="#17181a" stroke-width="1.7" stroke-linecap="round"><circle cx="9" cy="9.2" r="3"></circle><path d="M3.8 18.6c.9-2.6 2.9-4 5.2-4s4.3 1.4 5.2 4"></path><circle cx="16.3" cy="10" r="2.4"></circle><path d="M15.9 14.7c2 .3 3.5 1.5 4.2 3.5"></path></svg>
            {{ $vuetify.t('$vuetify.groupOrder.title') }}
            <span class="go-tip-tap-ring"></span>
            <svg class="go-tip-cursor" viewBox="0 0 24 24" width="18" height="18"><path d="M5 3 17.5 10.2 11.8 11.6 9.4 17.2 Z" fill="var(--v-primary-base)" stroke="#fff" stroke-width="1"></path></svg>
          </span>
          <div class="go-tip-order-card">
            <div class="go-tip-order-card-title">{{ demoOrderCardTitle }}</div>
            <div class="go-tip-order-card-sub">{{ storeName }}</div>
          </div>
        </div>

        <div v-else-if="sceneIndex === 1" key="1" class="go-tip-scene go-tip-scene-1">
          <div class="go-tip-deadline-card">
            <div class="go-tip-deadline-row">
              <span class="go-tip-deadline-label">{{ $vuetify.t('$vuetify.groupOrder.deadlineTitle') }}</span>
              <span class="go-tip-specific-badge">{{ $vuetify.t('$vuetify.groupOrder.deadlineSpecificTime') }}</span>
            </div>
            <div class="go-tip-info-row go-tip-anim-fadeup-1">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#17181a" stroke-width="1.7" stroke-linecap="round"><circle cx="12" cy="12" r="8"></circle><path d="M12 7.5V12l3 2"></path></svg>
              {{ $vuetify.t('$vuetify.groupOrder.tooltipDemoDeadlineTimeExample') }}
            </div>
            <div class="go-tip-info-row go-tip-anim-fadeup-2">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#17181a" stroke-width="1.7" stroke-linecap="round"><rect x="3" y="5.5" width="18" height="13" rx="2.5"></rect><path d="M3 10h18"></path></svg>
              {{ $vuetify.t('$vuetify.groupOrder.tooltipDemoPaySub') }}
            </div>
          </div>
        </div>

        <div v-else-if="sceneIndex === 2" key="2" class="go-tip-scene go-tip-scene-2">
          <div class="go-tip-link-row">
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="#17181a" stroke-width="1.7" stroke-linecap="round"><path d="M9.5 14.5 14.5 9.5"></path><path d="M11 6.8l1.9-1.9a3.6 3.6 0 0 1 5.2 5.2L16.2 12"></path><path d="M13 17.2l-1.9 1.9a3.6 3.6 0 0 1-5.2-5.2L7.8 12"></path></svg>
            <span class="go-tip-link-text">{{ $vuetify.t('$vuetify.groupOrder.tooltipDemoLinkExample') }}</span>
            <span class="go-tip-copy-pill">{{ $vuetify.t('$vuetify.groupOrder.copy') }}</span>
          </div>
          <div class="go-tip-qr-row">
            <span class="go-tip-qr-box">
              <svg viewBox="0 0 33 33" width="46" height="46" fill="var(--v-primary-base)"><rect x="2" y="2" width="9" height="9" fill="none" stroke="var(--v-primary-base)" stroke-width="2"></rect><rect x="5" y="5" width="3" height="3"></rect><rect x="22" y="2" width="9" height="9" fill="none" stroke="var(--v-primary-base)" stroke-width="2"></rect><rect x="25" y="5" width="3" height="3"></rect><rect x="2" y="22" width="9" height="9" fill="none" stroke="var(--v-primary-base)" stroke-width="2"></rect><rect x="5" y="25" width="3" height="3"></rect><rect x="14" y="3" width="3" height="3"></rect><rect x="14" y="8" width="2" height="2"></rect><rect x="18" y="6" width="2" height="3"></rect><rect x="13" y="13" width="3" height="3"></rect><rect x="18" y="14" width="3" height="2"></rect><rect x="23" y="14" width="2" height="3"></rect><rect x="27" y="16" width="3" height="2"></rect><rect x="14" y="19" width="2" height="3"></rect><rect x="18" y="21" width="3" height="3"></rect><rect x="14" y="26" width="3" height="2"></rect><rect x="19" y="27" width="2" height="3"></rect><rect x="24" y="22" width="3" height="3"></rect><rect x="27" y="27" width="3" height="3"></rect></svg>
            </span>
            <div class="go-tip-avatars-col">
              <div class="go-tip-avatars-row">
                <span class="go-tip-avatar go-tip-avatar-1">T</span>
                <span class="go-tip-avatar go-tip-avatar-2">M</span>
                <span class="go-tip-avatar go-tip-avatar-3">A</span>
              </div>
              <span class="go-tip-joined-text">{{ $vuetify.t('$vuetify.groupOrder.tooltipDemoPeopleJoined', [3]) }}</span>
            </div>
          </div>
        </div>

        <div v-else key="3" class="go-tip-scene go-tip-scene-3">
          <div class="go-tip-flying-squares">
            <span class="go-tip-square go-tip-square-1"></span>
            <span class="go-tip-square go-tip-square-2"></span>
            <span class="go-tip-square go-tip-square-3"></span>
          </div>
          <div class="go-tip-cart-pill">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#17181a" stroke-width="1.7" stroke-linecap="round"><circle cx="9.5" cy="19.5" r="1.4"></circle><circle cx="16.5" cy="19.5" r="1.4"></circle><path d="M3.5 4.5h2.2l2.2 11h9.3l1.9-7.6H6.4"></path></svg>
            <span class="go-tip-cart-label">{{ $vuetify.t('$vuetify.groupOrder.tooltipDemoGroupCartLabel') }}</span>
            <span class="go-tip-cart-count">3</span>
          </div>
          <div class="go-tip-checkout-row">
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="var(--v-primary-base)" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>
            {{ $vuetify.t('$vuetify.groupOrder.tooltipDemoOneCheckout') }}
          </div>
        </div>
      </div>

      <div class="go-tip-caption-wrap">
        <span class="go-tip-caption">{{ currentCaption }}</span>
        <span class="go-tip-dots">
          <span
            v-for="i in 4"
            :key="i"
            class="go-tip-dot"
            :class="{ 'go-tip-dot-active': (i - 1) === sceneIndex }"
          ></span>
        </span>
      </div>

      <button class="go-tip-start-btn" @click="onStart">{{ $vuetify.t('$vuetify.groupOrder.tooltipStartBtn') }}</button>
      <button class="go-tip-gotit-btn" @click="onDismiss">{{ $vuetify.t('$vuetify.groupOrder.tooltipGotItBtn') }}</button>
    </div>
  </div>
</template>

<script>
const SCENE_INTERVAL_MS = 2400;

export default {
  name: 'GroupOrderOnboardingTooltip',
  props: {
    storeName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      sceneIndex: 0,
      timer: null
    };
  },
  computed: {
    demoOrderCardTitle() {
      const name = this.$store.getters.getFirstName;
      return name ? `${name}'s Group Order` : this.$vuetify.t('$vuetify.groupOrder.title');
    },
    currentCaption() {
      const captions = [
        this.$vuetify.t('$vuetify.groupOrder.tooltipScene1Caption'),
        this.$vuetify.t('$vuetify.groupOrder.tooltipScene2Caption'),
        this.$vuetify.t('$vuetify.groupOrder.tooltipScene3Caption'),
        this.$vuetify.t('$vuetify.groupOrder.tooltipScene4Caption'),
      ];
      return captions[this.sceneIndex];
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.sceneIndex = (this.sceneIndex + 1) % 4;
    }, SCENE_INTERVAL_MS);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    onStart() {
      this.$emit('start');
    },
    onDismiss() {
      this.$emit('dismiss');
    }
  }
};
</script>

<style scoped>
@keyframes goTipFadeIn { from { opacity: 0; } }
@keyframes goTipPopIn { 0% { opacity: 0; transform: scale(.85); } 100% { opacity: 1; transform: scale(1); } }
@keyframes goTipFadeUp { 0% { opacity: 0; transform: translateY(8px); } 100% { opacity: 1; transform: translateY(0); } }
@keyframes goTipFlyIn { 0% { opacity: 0; transform: translateY(-22px); } 100% { opacity: 1; transform: translateY(0); } }
@keyframes goTipCursorTap { 0% { opacity: 0; transform: translate(84px,64px); } 30% { opacity: 1; } 55% { transform: translate(0,0) scale(1); } 68% { transform: translate(0,0) scale(.8); } 82% { transform: translate(0,0) scale(1); } 100% { opacity: 1; transform: translate(0,0); } }
@keyframes goTipTapRing { 0% { opacity: 0; transform: scale(.7); } 40% { opacity: 1; } 100% { opacity: 0; transform: scale(1.18); } }

.go-tip-pop {
  position: absolute;
  top: calc(100% + 14px);
  right: 0;
  z-index: 45;
  animation: goTipPopIn .35s cubic-bezier(.2,.8,.25,1) both;
}
.go-tip-arrow {
  position: absolute;
  top: -7px;
  right: 24px;
  width: 14px;
  height: 14px;
  background: #fff;
  transform: rotate(45deg);
  border-left: 1px solid #ececee;
  border-top: 1px solid #ececee;
}
.go-tip-card {
  background: #fff;
  border: 1px solid #ececee;
  border-radius: 16px;
  box-shadow: 0 18px 48px rgba(15,16,18,.28);
  padding: 14px;
  width: 300px;
  max-width: calc(100vw - 32px);
}
.go-tip-header {
  display: flex;
  align-items: center;
  gap: 8px;
}
.go-tip-badge {
  background: var(--v-primary-base);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.2px;
  border-radius: 999px;
  padding: 4px 8px;
}
.go-tip-title {
  font-size: 14.5px;
  font-weight: 700;
}
.go-tip-close {
  margin-left: auto;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 999px;
  background: #f1f2f3;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.go-tip-close:hover { background: #e4e5e7; }

.go-tip-demo {
  margin-top: 11px;
  height: 150px;
  background: #f6f7f8;
  border: 1px solid #eceded;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
}
.go-tip-scene {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: goTipFadeIn .3s;
}
.go-tip-scene-0 { gap: 10px; }
.go-tip-scene-2 { gap: 8px; }
.go-tip-scene-3 { gap: 9px; }

.go-tip-fake-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: #fff;
  border: 1px solid #dcdee0;
  border-radius: 999px;
  padding: 8px 15px;
  font-size: 12px;
  font-weight: 600;
}
.go-tip-tap-ring {
  position: absolute;
  inset: -5px;
  border: 2px solid var(--v-primary-base);
  border-radius: 999px;
  opacity: 0;
  animation: goTipTapRing .7s ease-out .8s 1 both;
}
.go-tip-cursor {
  position: absolute;
  right: -14px;
  bottom: -16px;
  animation: goTipCursorTap 1.5s ease-out both;
  z-index: 3;
}
.go-tip-order-card {
  background: #fff;
  border: 1px solid #e6e7e9;
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(15,16,18,.10);
  padding: 9px 13px;
  width: 195px;
  animation: goTipPopIn .35s ease 1.15s both;
}
.go-tip-order-card-title { font-size: 11.5px; font-weight: 700; }
.go-tip-order-card-sub { font-size: 10px; color: #8a8e92; margin-top: 2px; }

.go-tip-deadline-card {
  background: #fff;
  border: 1px solid #e6e7e9;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(15,16,18,.10);
  padding: 11px 13px;
  width: 225px;
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.go-tip-deadline-row { display: flex; align-items: center; gap: 8px; }
.go-tip-deadline-label { font-size: 11.5px; font-weight: 700; }
.go-tip-specific-badge {
  margin-left: auto;
  background: var(--v-primary-base);
  color: #fff;
  font-size: 9.5px;
  font-weight: 600;
  border-radius: 999px;
  padding: 4px 9px;
  animation: goTipPopIn .3s ease .25s both;
}
.go-tip-info-row {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f5f6f7;
  border-radius: 8px;
  padding: 7px 10px;
  font-size: 11px;
  font-weight: 600;
}
.go-tip-anim-fadeup-1 { animation: goTipFadeUp .35s ease .45s both; }
.go-tip-anim-fadeup-2 { animation: goTipFadeUp .35s ease .7s both; }

.go-tip-link-row {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid #e6e7e9;
  border-radius: 8px;
  padding: 6px 10px;
  animation: goTipPopIn .35s both;
}
.go-tip-link-text { font-size: 10.5px; color: #55585b; }
.go-tip-copy-pill {
  background: var(--v-primary-base);
  color: #fff;
  font-size: 9.5px;
  font-weight: 700;
  border-radius: 6px;
  padding: 3px 8px;
}
.go-tip-qr-row { display: flex; align-items: center; gap: 14px; }
.go-tip-qr-box {
  background: #fff;
  border: 1px solid #e6e7e9;
  border-radius: 8px;
  padding: 4px;
  display: inline-flex;
  animation: goTipPopIn .35s ease .2s both;
}
.go-tip-avatars-col { display: flex; flex-direction: column; gap: 5px; }
.go-tip-avatars-row { display: flex; }
.go-tip-avatar {
  width: 24px;
  height: 24px;
  border-radius: 999px;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #f6f7f8;
}
.go-tip-avatar-1 { background: var(--v-primary-base); animation: goTipPopIn .3s ease .5s both; }
.go-tip-avatar-2 { background: #3c4043; margin-left: -7px; animation: goTipPopIn .3s ease .68s both; }
.go-tip-avatar-3 { background: #6d7175; margin-left: -7px; animation: goTipPopIn .3s ease .86s both; }
.go-tip-joined-text { font-size: 10.5px; color: #8a8e92; animation: goTipFadeUp .3s ease 1s both; }

.go-tip-flying-squares { display: flex; gap: 10px; }
.go-tip-square { width: 13px; height: 13px; border-radius: 4px; }
.go-tip-square-1 { background: #dfe1e3; animation: goTipFlyIn .4s ease .15s both; }
.go-tip-square-2 { background: #c9cccf; animation: goTipFlyIn .4s ease .38s both; }
.go-tip-square-3 { background: #b1b4b7; animation: goTipFlyIn .4s ease .6s both; }
.go-tip-cart-pill {
  position: relative;
  display: flex;
  align-items: center;
  gap: 9px;
  background: #fff;
  border: 1px solid #e6e7e9;
  border-radius: 999px;
  padding: 8px 15px;
  box-shadow: 0 8px 20px rgba(15,16,18,.10);
}
.go-tip-cart-label { font-size: 11.5px; font-weight: 700; }
.go-tip-cart-count {
  width: 18px;
  height: 18px;
  background: var(--v-primary-base);
  color: #fff;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  animation: goTipPopIn .3s ease .85s both;
}
.go-tip-checkout-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10.5px;
  color: #55585b;
  animation: goTipFadeUp .35s ease 1.05s both;
}

.go-tip-caption-wrap {
  margin-top: 9px;
  min-height: 36px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
}
.go-tip-caption { font-size: 12px; font-weight: 600; color: #3c4043; text-align: center; }
.go-tip-dots { display: flex; gap: 5px; align-items: center; }
.go-tip-dot {
  display: inline-block;
  height: 6px;
  width: 6px;
  border-radius: 999px;
  background: #c9cccf;
  transition: all .25s ease;
}
.go-tip-dot-active {
  width: 16px;
  background: var(--v-primary-base);
}

.go-tip-start-btn {
  margin-top: 8px;
  width: 100%;
  height: 44px;
  background: var(--v-primary-base);
  color: #fff;
  border: none;
  border-radius: 999px;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
}
.go-tip-start-btn:hover { opacity: .92; }
.go-tip-gotit-btn {
  margin-top: 2px;
  width: 100%;
  height: 36px;
  background: none;
  border: none;
  font-size: 12.5px;
  font-weight: 600;
  color: #6f7377;
  cursor: pointer;
}

</style>
